import type { ModalName } from '@coursera/event-pulse-types';
import { createTrackerStore } from '@coursera/event-pulse/react';

type AuthModalData = {
  modalName: ModalName;
};

export const [AuthModalTrackerContextProvider, useAuthModalTrackerContext] = createTrackerStore<AuthModalData>();
